import { store } from "@/lib/store";
import { requirePermission } from "@/lib/permissions";
import {
  planAppointmentBulkUpload,
  type BulkUploadPlan,
  type PlannedAppointmentRow,
} from "@/app/shared/appointments/bulk-upload-plan";
import type { BulkUploadResult } from "@/app/shared/appointments/bulk-upload-import";
import { bookBulkUploadRows } from "@/services/appointment-booking.service";
import type { VendorAppointmentBulkUploadRow } from "@/app/shared/appointments/bulk-upload-parser";

export async function planBulkUpload(rows: VendorAppointmentBulkUploadRow[]): Promise<BulkUploadPlan> {
  await requirePermission("appointments.create");

  const vendorOrgId = store.getState().organization.activeOrgId;
  if (!vendorOrgId) {
    throw new Error("Organization not set");
  }

  return planAppointmentBulkUpload(rows, { kind: "vendor", vendorOrgId });
}

export async function bulkUploadVendorAppointments(
  planned: PlannedAppointmentRow[],
  onProgress?: (completed: number, total: number) => void
): Promise<BulkUploadResult> {
  return bookBulkUploadRows(planned, onProgress);
}
